.skip-now {
    width: 85px;
}
